import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import CASES from '../data/cases';

export default function CaseStudies() {
  return (
    <>
      <PageHero
        modifier="case-studies"
        kicker="Client Outcomes"
        title="Case Studies"
        desc="Real transformation results delivered for enterprises across manufacturing, retail, utilities and logistics."
      />
      <section className="section">
        <div className="container grid grid-2 animate-cards">
          {CASES.map((c, i) => (
            <div className="card card--case" key={i}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div className="card-tag">{c.category}</div>
                <span style={{ fontSize: 11, color: 'var(--muted)' }}>{c.industry}</span>
              </div>
              <h3>{c.title}</h3>
              <p style={{ fontSize: 13, color: 'var(--muted)', margin: 0 }}>{c.subtitle}</p>
              <div className="case-metrics">
                {c.metrics.map((m, j) => (
                  <div key={j}>
                    <span className="case-metric-val">{m.val}</span>
                    <span className="case-metric-lbl">{m.lbl}</span>
                  </div>
                ))}
              </div>
              <div className="tech-pills">
                {c.tech.map((t, j) => <span className="tech-pill" key={j}>{t}</span>)}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
                <span style={{ fontSize: 12, color: 'var(--muted)' }}>&#x23F1; {c.duration}</span>
                <Link to={`/case-studies/${c.slug}`} className="link" style={{ fontSize: 13 }}>Read study &#8594;</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
